import classNames from 'classnames';
import React from 'react';

type Props = {
    name: string;
    on: boolean;
    setOn: (value: React.SetStateAction<boolean>) => void;
};

export const ProSwitch = ({ name, on, setOn }: Props) => {
    return (
        <div className="ProSwitch" onClick={() => setOn((cur) => !cur)}>
            {name}
            <div className={classNames('ProSwitch__switch', on && 'ProSwitch--aktive')} />
        </div>
    );
};
